var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0005C20 5.58605 17.1389 1.8424 13.1704 0.516357V19.4841C17.1389 18.158 20 14.4146 20 10.0005Z",
    fill: "url(#paint0_linear_44_1415)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0005C0 14.4146 2.8614 18.158 6.82984 19.4841V0.516357C2.8614 1.8424 0 5.58605 0 10.0005Z",
    fill: "url(#paint1_linear_44_1415)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 20.0005C11.1087 20.0005 12.1737 19.8171 13.1706 19.4839V0.516382C12.1739 0.18342 11.1087 0 9.99999 0C8.89149 0 7.82606 0.18342 6.82959 0.516382V19.4841C7.82606 19.8171 8.89149 20.0005 9.99999 20.0005Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1415",
    x1: 16.5854,
    y1: 0.516211,
    x2: 16.5854,
    y2: 19.4839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_1415",
    x1: 6.82975,
    y1: 10.0001,
    x2: 0,
    y2: 10.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3150A3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/FR.14bf0bbb09500a18db68700fca2a81dd.svg";
export { ForwardRef as ReactComponent };